var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBuildingHospital = function SvgBuildingHospital(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "building-hospital_svg___x32_",
    width: 800,
    height: 800,
    viewBox: "0 0 512 512"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".building-hospital_svg__st0{fill:#000}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m256 0-9 5.031L8.734 138.266V512h494.532V138.266zm210.359 475.094H318.75V340.781H193.266v134.313H45.641V159.906L256 42.281l210.359 117.625z",
    className: "building-hospital_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.141 359.219h36.953v44.078h-36.953zM104.141 261.438h36.953v44.063h-36.953zM237.516 261.438h36.969v44.063h-36.969zM235.359 103.969v37.156h-37.171v41.313h37.171v37.156h41.282v-37.156h37.172v-41.313h-37.172v-37.156zM370.828 261.438h34.656v44.063h-34.656zM370.906 359.219h36.969v44.078h-36.969z",
    className: "building-hospital_svg__st0"
  })));
};
export default SvgBuildingHospital;